// ProgressRing.tsx — the circular progress ring pattern cited across the fitness-app category
// (Apple Fitness+ activity rings, Fitbit's dashboard). Hand-rolled SVG, no dependency. Only ever
// shown against a REAL stated goal (training_profile.days_per_week) — never an invented target.
export function ProgressRing({
  value, target, size = 46, stroke = 5, color = "var(--accent)",
}: {
  value: number;
  target: number;
  size?: number;
  stroke?: number;
  color?: string;
}) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = target > 0 ? Math.min(1, value / target) : 0;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ flexShrink: 0, transform: "rotate(-90deg)" }} aria-hidden>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--elev-2)" strokeWidth={stroke} />
      <circle
        cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
        strokeDasharray={c} strokeDashoffset={c * (1 - pct)} strokeLinecap="round"
        style={{ transition: "stroke-dashoffset 300ms ease" }}
      />
      <text x={size / 2} y={size / 2} textAnchor="middle" dominantBaseline="central"
        transform={`rotate(90 ${size / 2} ${size / 2})`}
        style={{ fill: "var(--ink-1)", fontSize: size * 0.32, fontWeight: 800 }}>
        {value}
      </text>
    </svg>
  );
}
